import {
	TIMEOFF_REQUEST,
	TIMEOFF_REQUEST_SUCCESS,
	TIMEOFF_REQUEST_FAILURE
} from '../../constants/index';

const initialState = {
	data: null,
	loading: false,
	error: null
};

const timeOffRequestReducer = (state = initialState, action) => {
	switch (action.type) {
		case TIMEOFF_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null
			};
		case TIMEOFF_REQUEST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case TIMEOFF_REQUEST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			};
		default:
			return state;
	}
};

export default timeOffRequestReducer;
